export default function BajaMatricula() {
  return (
    <section id="titulo" className="section titulo-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Baja de Matrícula</h2>
        <p>
          Trámite para la baja de matrícula profesional del Colegio de
          Fonoaudiólogos de La Pampa.
        </p>
      </div>

      <div className="container fade-up">
        <div className="titulo-card">
          <div className="titulo-card-body">
            <p className="description">
              Para el trámite de baja de matrícula es necesario completar la
              Solicitud de Baja de Matrícula y la Declaración Jurada de cese de
              actividades, y presentarlas en la sede del Colegio.
            </p>

            <div className="steps">
              <div className="step">
                <div className="step-num">1</div>
                <div className="step-text">
                  Descargar y completar la{" "}
                  <strong>Nota de Solicitud de Baja de Matrícula</strong>
                </div>
              </div>
              <div className="step">
                <div className="step-num">2</div>
                <div className="step-text">
                  Descargar y completar la{" "}
                  <strong>Declaración Jurada de cese de actividades</strong>
                </div>
              </div>
              <div className="step">
                <div className="step-num">3</div>
                <div className="step-text">
                  Presentar ambos formularios completos en la sede del Colegio
                </div>
              </div>
            </div>

            <div className="info-box">
              <i className="bi bi-info-circle-fill"></i>
              <span>
                Ante cualquier consulta comunicarse con la sede del Colegio al{" "}
                <strong>02954-702284</strong> o por email a{" "}
                <strong>cofolp@gmail.com</strong>
              </span>
            </div>

            <div className="download-actions">
              <a
                href="/assets/portal/docs/SOLICITUD_DE_BAJA_DE_MATRICULACION.pdf"
                className="btn-download primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-download"></i>
                Descargar Solicitud de Baja
              </a>
              <a
                href="/assets/portal/docs/DECLARACION_JURADA_(cese_actividades_BAJA_MATRICULA).pdf"
                className="btn-download secondary"
                target="_blank"
              >
                <i className="bi bi-download"></i>
                Descargar Declaración Jurada
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
